import services from '@/config/services'
import FileManager from '@/services/ask-file-manager/index.js'

export default class UtilityBolloService{
  constructor(http, eventBus){
    this.http = http
    this.eventBus = eventBus
    this.baseUrl = `${services.ask_api.url}/management`
    this.filemanager = new FileManager()
  }

  async getStatisticheByYear(year){
    let items;
    // let totalItems = 0

    const url = `${this.baseUrl}/utility/bollo/${year}/statistiche`

    try {
      let res = await this.http.get(url)
      items = res.data
      // totalItems = res.meta.total_items
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')
      
      // eslint-disable-next-line no-unsafe-finally
      return items  
    }
  }
}
